export default {
  initialValue: 'حد پایین',
  title: 'عنوان',
  groups: 'دسته بندی',
  notShownReports:
    'گزارش‌های زیر قابلیت مشاهده در نمایش جدولی (کارت امتیازی متوازن) را ندارند. لطفا بررسی کنید که تقسیم بندی گزارش فقط بر روی زمان یا بر روی بخش باشد.',
  print: 'چاپ',
  noDataFound:
    'هیچ داده ای در این بازه زمانی یافت نشد لطفا بازه زمانی مورد نظر را انتخاب کنید.',
  other: 'سایر',
  hideEmptyRows: 'پنهان کردن سطرهای بدون داده',
  showEmptyRows: 'نمایش سطر‌های بدون داده',

  percentageValue(percentage: string) {
    return `٪ ${percentage}`;
  },
  target: 'هدف',
  unit: 'واحد',
  untilDate(date: string) {
    return `تا ${date}`;
  },
  withoutData: '---',
  average: 'میانگین',
  totalRealization: 'میانگین درصد تحقق',
  totalRealizationBound: 'میانگین درصد تحقق محدود شده',
  totalRealizationBoundInfo:
    'مقادیر بیشتر از ۱۰۰ به ۱۰۰ و کمتر از ۰ به ۰ تبدیل می‌شوند.',
};
